import { useAPIRequestClient } from './use-api-request-client';

/**
 * Legacy API client.
 * @deprecated Use 'tanstack/react-query' instead.
 */
export default {
  useRequestClient: useAPIRequestClient,
};
